module.exports = __webpack_public_path__ + "img/reset-password.9249da8e.svg";